export default function RoadHopperIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect width="64" height="64" rx="12" fill="#8EE05A" />
      <rect x="0" y="8" width="64" height="18" fill="#4FB8F2" />
      <rect x="6" y="13" width="26" height="8" fill="#9A6A3E" />
      <rect x="6" y="11" width="26" height="3" fill="#B98A5A" />
      <rect x="0" y="34" width="64" height="18" fill="#545B6E" />
      <path d="M4 43h10M22 43h10M40 43h10" stroke="#E8ECF4" strokeWidth="2" />
      <rect x="40" y="36" width="20" height="11" fill="#E84A4A" />
      <rect x="40" y="33" width="20" height="4" fill="#FF7A7A" />
      <rect x="45" y="30" width="10" height="4" fill="#FFB0B0" />
      <rect x="23" y="30" width="6" height="14" fill="#F4E1C1" />
      <rect x="25" y="32" width="2" height="9" fill="#FF9EB5" />
      <rect x="33" y="30" width="6" height="14" fill="#F4E1C1" />
      <rect x="35" y="32" width="2" height="9" fill="#FF9EB5" />
      <rect x="21" y="47" width="20" height="14" fill="#E3CBA4" />
      <rect x="21" y="42" width="20" height="6" fill="#FBEFD9" />
      <rect x="24" y="50" width="3" height="3" fill="#1b1b2a" />
      <rect x="35" y="50" width="3" height="3" fill="#1b1b2a" />
      <rect x="29.5" y="53" width="3" height="2" fill="#FF7FA0" />
      <rect x="29.5" y="55" width="3" height="3" fill="#FFFFFF" />
    </svg>
  );
}
